var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-badge",style:(_vm.variantStyles)},[(_vm.imageUrl)?_c('img',{staticClass:"c-badge__image",attrs:{"src":_vm.imageUrl,"alt":_vm.altText || 'Badge'}}):_c('div',{staticClass:"c-badge__slot",class:_vm.backgroundClass,style:(_vm.slotStyles)},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }